
import pdf from 'vue-pdf'
var param = [];

var loadingTask;

export default {
  name: 'AffiliateDoc',
  components: {
    pdf
  },
  data() {
    return {
      src: "",
      url : "",
      numPages: 0,
    }
  },
  mounted() {

  },
  created() {
    console.log(this.$route)
    param = this.$route.params.pdf;

    if (param === undefined) {
      param = atob(this.$route.query.pdf);
    }
    console.log(param)
    this.url = param;

    // loadingTask = pdf.createLoadingTask('QHMC Operating Hours - Christmas Holiday 2020 (Updated on 20201216) - VTC.pdf')

    loadingTask = pdf.createLoadingTask(param)

    this.src = loadingTask
    this.src.promise.then(pdf => {
      this.numPages = pdf.numPages;
    });
  },
  methods: {
    async DownloadPdf(url){
      window.open(url, '_blank');
    }
  }
}

